import { render, staticRenderFns } from "./PatientItem.vue?vue&type=template&id=d10feace&"
import script from "./PatientItem.vue?vue&type=script&lang=js&"
export * from "./PatientItem.vue?vue&type=script&lang=js&"
import style0 from "./PatientItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports